import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

interface Props {
  text: string;
  shadow?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    text: null,
    shadow: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ssg-button", { shadow: __props.shadow }])
  }, _toDisplayString(__props.text), 3))
}
}

})